module.exports = __webpack_public_path__ + "img/unc-logo-footer.4a3c3857.png";